import { render } from "./BannerDialog.vue?vue&type=template&id=04b579c8&scoped=true"
import script from "./BannerDialog.vue?vue&type=script&lang=js"
export * from "./BannerDialog.vue?vue&type=script&lang=js"

import "./BannerDialog.vue?vue&type=style&index=0&id=04b579c8&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-04b579c8"]])

export default __exports__